import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 1023px) {
    padding-top: 86px;
    padding-bottom: 70px;
    background-color: #000;
  }

  @media (min-width: 1024px) {
    padding-top: 143px;
    background-color: #171717;
    background-image: linear-gradient(
      183deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 0) 50%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  .slick-dots {
    bottom: 18px;
    margin: 0;
  }

  .slick-dots li button::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    border: 2px solid #fff;
    border-radius: 20px;
    opacity: 1;
  }

  .slick-dots li.slick-active button::before {
    background-color: #fff;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1023px) {
    padding: 0 25px;
  }

  @media (min-width: 1024px) {
    max-width: 1550px;
    padding: 0 60px;
  }
`;

export const Subtitle = styled.div`
  color: #c49f3f;
  font-family: "Rockwell";
  text-align: center;
  text-transform: uppercase;
  transform: rotate(357deg);

  @media (max-width: 1023px) {
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 26px;
  }
`;

export const Title = styled.div`
  position: relative;
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-align: center;
  text-transform: uppercase;
  transform: rotate(357deg);

  @media (max-width: 1023px) {
    margin-top: 10px;
    font-size: 38px;
  }

  @media (min-width: 1024px) {
    margin-top: 20px;
    margin-bottom: 100px;
    font-size: 70px;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 19 19' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23bb8b2b' d='M 11.086 13.344 L 17.628 16.034 L 13.918 10.011 L 18.5 4.621 L 11.624 6.289 L 7.914 0.267 L 7.375 7.32 L 0.5 8.988 L 7.043 11.68 L 6.505 18.733 L 11.086 13.344 Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 1023px) {
      top: 10px;
      width: 16px;
      height: 16px;
    }

    @media (min-width: 1024px) {
      top: 25px;
      width: 20px;
      height: 20px;
    }
  }

  &::before {
    @media (max-width: 1023px) {
      left: -25px;
    }

    @media (min-width: 1024px) {
      left: -40px;
    }
  }

  &::after {
    @media (max-width: 1023px) {
      right: -25px;
    }

    @media (min-width: 1024px) {
      right: -40px;
    }
  }
`;

export const CardsWrapper = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 1023px) {
    max-width: 600px;
    margin-top: 60px;

    & + & {
      margin-top: 50px;
      padding-top: 50px;
      background-image: linear-gradient(
        to right,
        #818386 60%,
        rgba(255, 255, 255, 0) 0%
      );
      background-size: 20px 1px;
      background-repeat: repeat-x;
      background-position-y: 0;
    }
  }

  @media (min-width: 1024px) {
    display: flex;

    & + & {
      margin-top: 40px;
      flex-direction: row-reverse;
    }
  }
`;

export const GrandSlider = styled.div`
  position: relative;

  @media (max-width: 1023px) {
    width: 100%;
    height: 260px;
  }

  @media (min-width: 1024px) {
    width: 50%;
    height: 600px;
  }

  img {
    height: 100%;
    object-fit: cover;
  }
`;

export const GrandTextContainer = styled.div`
  background-color: #000;

  @media (max-width: 1023px) {
    margin-top: 32px;
  }

  @media (min-width: 1024px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
  }
`;

export const GrandText = styled.div`
  @media (min-width: 1024px) {
    max-width: 350px;
  }

  @media (min-width: 1280px) {
    max-width: 480px;
  }
`;

export const Badge = styled.img`
  display: block;
  width: auto;

  @media (max-width: 1023px) {
    height: ${p => (p.$isGrand ? "55px" : "42px")};
  }

  @media (min-width: 1024px) {
    height: ${p => (p.$isGrand ? "65px" : "50px")};
  }
`;

export const CardTitle = styled.h5`
  margin-bottom: 0;
  color: #fff;
  font-weight: 900;
  font-family: "YWFT Ultramagnetic";
  text-transform: uppercase;

  @media (max-width: 1023px) {
    margin-top: 24px;
    font-size: 24px;
    line-height: 1.33;

    span {
      display: none;
    }

    sup {
      font-size: 14px;
    }
  }

  @media (min-width: 1024px) {
    margin-top: 29px;
    font-size: 34px;
    line-height: 1.29;

    sup {
      font-size: 22px;
    }
  }
`;

export const List = styled.ul`
  list-style: none;

  @media (max-width: 1023px) {
    margin-top: 24px;
  }

  @media (min-width: 1024px) {
    margin-top: 24px;
  }
`;

export const ListItem = styled.li`
  position: relative;

  @media (max-width: 1023px) {
    padding-left: 25px;
    color: #fff;
    font-size: 14px;
    line-height: 1.43;

    &:not(:last-of-type) {
      margin-bottom: 8px;
    }

    span {
      position: relative;
      top: 5px;
      font-size: 22px;
      line-height: 18px;
    }
  }

  @media (min-width: 1024px) {
    padding-left: 32px;
    color: #c3c3c3;
    font-size: 16px;
    line-height: 1.38;

    &:not(:last-of-type) {
      margin-bottom: 14px;
    }

    span {
      position: relative;
      top: 6px;
      font-size: 25px;
      line-height: 17px;
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 1px;
    left: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17 18'%3E%3Cpath fill='%23c49f3f' d='m5.674 17.716.508-6.658L.005 8.517l6.49-1.574.508-6.658 3.5 5.685 6.491-1.574-4.325 5.088 3.5 5.685-6.175-2.54-4.32 5.087ZM3.233 8.763l4 1.647-.329 4.314 2.8-3.3 4 1.646-2.27-3.684 2.8-3.3-4.205 1.02L7.76 3.423l-.329 4.314-4.198 1.026Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 1279px) {
      width: 15px;
      height: 16px;
    }

    @media (min-width: 1280px) {
      width: 17px;
      height: 18px;
    }

    @media (min-width: 1600px) {
      top: 0;
    }
  }
`;
